import IsUnauthenticated from "@/permissions/IsUnauthenticated";

export default [
  {
    path: "/login",
    name: "login",
    component: () =>
      import(
        /* webpackChunkName: "login" */ "@/modules/auth/views/Login/index.vue"
      ),
    meta: {
      permissions: [IsUnauthenticated()]
    }
  }
];
